import React, { useState, useEffect } from 'react';
import { Header, ApiKeySection, MainContent } from './components';
import { storeApiToken, getApiToken, removeApiToken } from './utils/cookies';
import './styles/App.css';

function App() {
  const [isConnected, setIsConnected] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);
  const [loadedFromCookie, setLoadedFromCookie] = useState(false);

  // Check for existing API token in cookies on component mount
  useEffect(() => {
    const savedApiToken = getApiToken();
    if (savedApiToken) {
      setApiKey(savedApiToken);
      setIsConnected(true);
      setLoadedFromCookie(true);
      console.log('API Key loaded from cookie');
    }
    setIsInitialized(true);
  }, []);

  const handleApiKeySubmit = (apiKey: string) => {
    console.log('API Key submitted:', apiKey);
    setApiKey(apiKey);
    setIsConnected(true);
    setLoadedFromCookie(false); // This is a new manual submission
    
    // Store the API token in a secure cookie
    storeApiToken(apiKey);
  };

  const handleDisconnect = () => {
    setIsConnected(false);
    setApiKey('');
    setLoadedFromCookie(false);
    
    // Remove the API token from cookies
    removeApiToken();
  };

  // Don't render until we've checked for existing tokens
  if (!isInitialized) {
    return (
      <div className="App">
        <div className="loading-app">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="app-container">
        <ApiKeySection 
          onApiKeySubmit={handleApiKeySubmit} 
          onDisconnect={handleDisconnect}
          isConnected={isConnected}
          loadedFromCookie={loadedFromCookie}
        />
        <MainContent isConnected={isConnected} apiKey={apiKey} />
      </div>
    </div>
  );
}

export default App;
